import { createFileRoute } from '@tanstack/react-router';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Users } from 'lucide-react';

export const Route = createFileRoute('/_dashboard/admin/org/users')({
  component: OrgUsersPage,
});

function OrgUsersPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold">Team Members</h1>
        <p className="text-muted-foreground">Manage your organization's team members</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            Team Members
          </CardTitle>
          <CardDescription>Invite, manage, and remove team members</CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">Team management interface coming soon...</p>
        </CardContent>
      </Card>
    </div>
  );
}
